export function applyLayerVisibility(map, visibleTitles = []) {
  const layers = map.getAllLayers()

  layers.forEach((layer) => {
    const title = layer.get('title')
    const isVisible = visibleTitles.includes(title)

    if (layer.get('type') === 'base' && isVisible) {
      layers.forEach((l) => {
        if (l.get('type') === 'base') {
          l.setVisible(false)
        }
      })
    }

    layer.setVisible(isVisible)
  })
}

export function getVisibleLayers(map) {
  return map.getAllLayers()
    .filter(layer => layer.getVisible())
    .map(layer => layer.get('title'))
}
